import * as React from 'react';
import { CPlannerTask } from '../../Entity/PlannerTaskObj';
import { MIAPACons } from '../../Utils/MipaConstant';
import './planner.scss';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import Moment from 'react-moment';
import { Facepile, } from 'office-ui-fabric-react/lib/Facepile';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { DirectionalHint } from 'office-ui-fabric-react/lib/ContextualMenu';
import { DayOfWeek } from 'office-ui-fabric-react/lib/DatePicker';
import { GraphRequest } from '../../Utils/GraphRequest';
import TaskCheckList from './TaskChecklist';
import TaskAttachmentList from './TaskAttachment';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import TaskCategory from './TaskCategory';
export interface IProps {
  data?: CPlannerTask;
  Users;
  facepileProps;
  //facepilePropsAssignedby;
  Header;
  Phrases;
  UpdatePlannerTask;
  // Progress;
}
export interface IContextualMenuState {
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  DetailCalloutVisible?: boolean;
  firstDayOfWeek?: DayOfWeek;
  DetailsEditCalloutVisible?: boolean;
  isLoading?: boolean;
  TaskDetails;
}




export default class PlannerTaskDetails extends React.Component<IProps, IContextualMenuState>{

  private _menuButtonElement: HTMLElement | null;
  private _DetailEditmenuButtonElement: HTMLElement | null;
   private plancategory = {
    category1: '',
    category2: '',
    category3: '',
    category4: '',
    category5: '',
    category6: '',
    loaded: false
  }; 
  private RequestPending = 0;
  private ProgressIsShowing = false;
  constructor(props: IProps) {
    super(props);
    this.state = {
      DetailCalloutVisible: false,
      directionalHint: DirectionalHint.topCenter,
      beakWidth: 16,
      TaskDetails: null,
      DetailsEditCalloutVisible: false,
      isLoading: false
    };
  }
  // UserEmail.split("@")[1]
  public render() {

    const { DetailCalloutVisible, beakWidth, TaskDetails, DetailsEditCalloutVisible } = this.state;

    let rowcss = "ms-Grid-row miparow " + 'detailrow';
    /*let categoryui = null;
    let cats = this.props.data.appliedCategories;
     if (cats) {
      categoryui = [];
      let catcss = 'task-details-category-tabdetail';
      if (cats.category1) {
        categoryui.push(<i key="cat1" className={[catcss, 'category1'].join(" ")} title={this.plancategory.category1}>{this.plancategory.category1}</i>);
      }
      if (cats.category2) {
        categoryui.push(<i key="cat2" className={[catcss, 'category2'].join(" ")} title={this.plancategory.category2}>{this.plancategory.category2}</i>);
      }
      if (cats.category3) {
        categoryui.push(<i key="cat3" className={[catcss, 'category3'].join(" ")} title={this.plancategory.category3}>{this.plancategory.category3}</i>);
      }
      if (cats.category4) {
        categoryui.push(<i key="cat4" className={[catcss, 'category4'].join(" ")} title={this.plancategory.category4}>{this.plancategory.category4}</i>);
      }
      if (cats.category5) {
        categoryui.push(<i key="cat5" className={[catcss, 'category5'].join(" ")} title={this.plancategory.category5}>{this.plancategory.category5}</i>);
      }
      if (cats.category6) {
        categoryui.push(<i key="cat6" className={[catcss, 'category6'].join(" ")} title={this.plancategory.category6}>{this.plancategory.category6}</i>);
      }
      categoryui.push(<div className="mtb8" style={{ "clear": 'both', 'marginBottom': '5px' }} />);
    } */

    return (
      <div style={{ cursor: 'pointer' }} ref={menuButton => (this._menuButtonElement = menuButton)} onClick={this._onMenuClicked} title={this.props.data.title} className='ellips'>{this.props.data.title}
        {DetailCalloutVisible ? (
          <Callout

            className="ms-Callout-callout"
            onDismiss={this._onCalloutDismiss}
            target={this._menuButtonElement}
            directionalHint={DirectionalHint.topAutoEdge}
            coverTarget={false}
            isBeakVisible={true}
            gapSpace={0}
            beakWidth={beakWidth}
          >
            <div className='detailcallout'>
              <div className='plannerdetailheader'>
                {this.props.data.title}
                {this.state.isLoading ? (
                  <div className="mipaloading">&nbsp;</div>
                ) : null}
              </div>
              <div className="ms-Callout-inner" style={{ padding: '10px' }}>
                <div className="ms-Callout-content ms-Grid">
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      <i className={["ms-Icon ms-Icon--PlannerLogo", 'detailbodyicon'].join(' ')} />
                      {this.props.data.planeName}
                    </div>
                  </div>
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      <i className={["ms-Icon ms-Icon--Package", 'detailbodyicon'].join(' ')} />
                      {this.props.data.bucketName}
                    </div>
                  </div>
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      <div className='assignecontainer'>
                        <Facepile {...this.props.facepileProps} />
                      </div>
                    </div>
                  </div>

                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      <i className={["ms-Icon ms-Icon--List", 'detailbodyicon'].join(' ')} />
                      {TaskDetails ?
                        (
                          <React.Fragment>
                            <i
                              className="ms-Icon ms-Icon--EditSolid12 desedit"
                              ref={menuButton => (this._DetailEditmenuButtonElement = menuButton)}
                              onClick={() => {
                                this.ChangeState('DetailsEditCalloutVisible', !this.state.DetailsEditCalloutVisible);

                              }}
                            />
                            <div style={{ whiteSpace: 'pre-wrap' }}>{TaskDetails.description}</div>
                          </React.Fragment>
                        ) :
                        <Spinner size={SpinnerSize.large} />}
                    </div>
                    {
                      DetailsEditCalloutVisible ? (
                        <Callout
                          className="ms-Callout-callout"
                          onDismiss={() => {
                            // this.ChangeState('DetailsEditCalloutVisible',false);
                          }}
                          target={this._DetailEditmenuButtonElement}
                          // directionalHint={directionalHint}
                          coverTarget={false}
                          isBeakVisible={true}
                          gapSpace={0}
                          beakWidth={beakWidth}>
                          <div className='plannerdetailheader'>
                            {this.props.Phrases.edittaskdescription}
                          </div>
                          <div className="ms-Callout-inner" style={{ padding: '10px' }}>
                            <div className="ms-Callout-content">

                              <textarea
                                onChange={(e) => {
                                  TaskDetails.description = e.target['value'];
                                  this.ChangeState('TaskDetails', TaskDetails);

                                }}
                                cols={40}
                                rows={10}
                                value={TaskDetails.description}
                              />

                            </div>
                            <div style={{ textAlign: "right", padding: 5 }}>
                              <DefaultButton
                                className="viewswitchbtn plannertask"
                                onClick={(event) => {
                                  this.EditTaskDescription();
                                }}
                                text={this.props.Phrases.save}
                              />
                            </div>
                          </div>
                        </Callout>

                      ) : null
                    }
                  </div>
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      {this.props.data.percentComplete == 0 ? <div><i className={["ms-Icon ms-Icon--CircleRing", 'detailbodyicon'].join(' ')} /> {this.props.Phrases.notstarted}</div> :
                        <div><i className={["ms-Icon ms-Icon--CircleHalfFull", 'detailbodyicon'].join(' ')} /> {this.props.Phrases.inprogress}</div>
                      }
                    </div>
                  </div>
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      <i className={["ms-Icon ms-Icon--Calendar", 'detailbodyicon'].join(' ')} />
                      <div>
                        {this.props.Phrases.start} : {this.props.data.startDateTime != null ? <Moment format=" DD MMM YY">{this.props.data.startDateTime}</Moment> : null}
                        <br />
                        {this.props.Phrases.due}:{this.props.data.dueDateTime!=null? <Moment format=" DD MMM YY">{this.props.data.dueDateTime.toString()}</Moment>:null}
                      </div>
                    </div>
                  </div>
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      {/*  <i className={["ms-Icon ms-Icon--Tag",'detailbodyicon'].join(' ')} />
                                                    <div>
                                                      {categoryui}
                                                    </div> */}
                      <TaskCategory AddCategoryMethod={(newcat) => {
                        let finalcat={};
                        for (const property in this.props.data.appliedCategories) {
                          finalcat[property]=false;
                        }
                        for (const property in newcat) {
                          finalcat[property]=true;
                        }
                        this.props.UpdatePlannerTask({ 'appliedCategories': finalcat });
                      }} Phrases={this.props.Phrases}
                        appliedCategories={this.props.data.appliedCategories}
                        categoryDescriptions={this.plancategory}
                      />
                    </div>
                  </div>
                  {this.props.data.checklistItemCount && this.props.data.checklistItemCount > 0 ?
                    <div className={rowcss}>
                      <div className="ms-Grid-col ms-sm12">
                        <TaskCheckList TaskDetails={TaskDetails} text={this.props.Phrases.completedcount.replace('{0}', parseInt(this.props.data.checklistItemCount) - parseInt(this.props.data.activeChecklistItemCount) + '/' + this.props.data.checklistItemCount)} />

                      </div>
                    </div>
                    : null}
                  {this.props.data.referenceCount && this.props.data.referenceCount > 0 ?
                    <div className={rowcss}>
                      <div className="ms-Grid-col ms-sm12">
                        <TaskAttachmentList TaskDetails={TaskDetails} text={this.props.Phrases.attachmentcount.replace('{0}', this.props.data.referenceCount)} />

                      </div>
                    </div>
                    : null}
                </div>
              </div>
            </div>
          </Callout>
        ) : null}
      </div>
    );
  }

  private _onCalloutDismiss = (): void => {
    this.setState({
      DetailCalloutVisible: false,
      DetailsEditCalloutVisible: false
    });
  }

  private _onMenuClicked = (): void => {
    if (this.state.TaskDetails == null) {
      this.LoadPlandetails();
      let detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.TaskDetail.replace('{0}', this.props.data.id) + Math.round(+new Date() / 1000);
      GraphRequest.GET(
        detailapi,
        this.props.Header,
        (detail) => {
          this.ChangeState('TaskDetails', detail.data);
        },
        (error) => {
          console.log('Error in read task details', error);
        },
        this.ShowHideProgress);
    }
    this.ChangeState('DetailCalloutVisible', !this.state.DetailCalloutVisible);
  }
  private LoadPlandetails = () => {
    if (!this.plancategory.loaded) {

      let detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.PlanDetailsbeta.replace('{0}', this.props.data.planId);
      GraphRequest.GET(
        detailapi,
        this.props.Header,
        (detail) => {
          this.plancategory = detail.data.categoryDescriptions;
          this.ChangeState('beakWidth', 16);
        },
        (error) => {

        },
        this.ShowHideProgress);
    }
  }
  private EditTaskDescription = () => {
    let taskdetails;
    let taskurl = MIAPACons.GraphAPI.GraphBaseURL +
      MIAPACons.GraphAPI.TaskDetail.replace("{0}", this.props.data.id) + Math.round(+new Date() / 1000);
    GraphRequest.GET(
      taskurl, this.props.Header,
      (response) => {
        if (response && response.data) {
          taskdetails = response.data;
          let header = { ...this.props.Header };
          let etag = taskdetails["@odata.etag"];
          header["If-Match"] = etag;
          header["Prefer"] = "return=representation";
          GraphRequest.Patch(
            taskurl, header, { description: this.state.TaskDetails.description },
            (detailsresponse) => {
              taskdetails = detailsresponse.data;
              this.setState({ TaskDetails: taskdetails, DetailsEditCalloutVisible: false, DetailCalloutVisible: true });

            },
            (detailserror) => {
              alert('Fail to create task');
            },
            this.ShowHideProgress);
        } else {
          alert('Task not available');
        }
      },
      (error) => {
        alert('Fail to create task');
      },
      this.ShowHideProgress);
  }
  private ShowHideProgress = value => {
    /*if(this.RequestPending==0 && value<0){
      return;
    }*/
    this.RequestPending += value;

    if (this.RequestPending <= 0) {
      this.RequestPending = 0;
      if (this.ProgressIsShowing) {
        this.ChangeState('isLoading', false);
        this.ProgressIsShowing = false;
      }
    } else if (this.ProgressIsShowing == false) {
      this.ProgressIsShowing = true;
      this.ChangeState('isLoading', true);
    }
  }
  private ChangeState = (prop, value) => {
    let prevstate = { ...this.state };
    prevstate[prop] = value;
    this.setState(prevstate);
  }
}
